import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import s from './ActionBarStrip.scss';
const ActionBarStrip = /*#__PURE__*/ forwardRef(({ className, children }, ref)=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(Section, {
        className: classnames(s['root'], className),
        ref: ref,
        "data-hook": BiDataHook.DEVIATION_ACTION_BAR
    }, /*#__PURE__*/ React.createElement(VisuallyHidden, null, /*#__PURE__*/ React.createElement(Heading, null, t('actionbar.a11y.heading'))), children);
});
ActionBarStrip.displayName = 'ActionBarStrip';
export default ActionBarStrip;
